import {
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
} from "@keita/lanepatrol-sdk";
import {
  CreateOrUpdateHlaLane,
  PresenceDistance,
} from "../../../hla/models/HlaLane";
import { DistanceTracking } from "./models";

export function applyAdjacentFeaturesToLane(
  lane: CreateOrUpdateHlaLane,
  distances: DistanceTracking,
) {
  const frontFeatures = lane.frontFacing
    ? lane.adjacentFeaturesRight
    : lane.adjacentFeaturesLeft;
  const backFeatures = lane.frontFacing
    ? lane.adjacentFeaturesLeft
    : lane.adjacentFeaturesRight;

  const [backSideMargin, frontSideMargin] = assumeFacilityMargins(lane);

  const frontSide = lane.frontFacing ? "right" : "left";
  const backSide = lane.frontFacing ? "left" : "right";

  if (distances.Parking[frontSide]) {
    frontFeatures.vehicleParking =
      distances.Parking[frontSide] < frontSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Parking[backSide]) {
    backFeatures.vehicleParking =
      distances.Parking[backSide] < backSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Building[frontSide]) {
    frontFeatures.objectOrLevelChange =
      distances.Building[frontSide] < frontSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Building[backSide]) {
    backFeatures.objectOrLevelChange =
      distances.Building[backSide] < backSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Path[frontSide]) {
    frontFeatures.sidewalk =
      distances.Path[frontSide] < frontSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Path[backSide]) {
    backFeatures.sidewalk =
      distances.Path[backSide] < backSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Street[frontSide]) {
    frontFeatures.roadLane =
      distances.Street[frontSide] < frontSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (distances.Street[backSide]) {
    backFeatures.roadLane =
      distances.Street[backSide] < backSideMargin + 1
        ? PresenceDistance.From0to1m
        : PresenceDistance.From1to3m;
  }

  if (
    distances.Rail[frontSide] &&
    lane.facilityType === FacilityType.MixedTrafficRoadLane
  ) {
    lane.tramOrTrainRails = true;
  }

  if (
    distances.Rail[backSide] &&
    lane.facilityType === FacilityType.MixedTrafficRoadLane
  ) {
    lane.tramOrTrainRails = true;
  }
}

// Returns [back side margin, front side margin]
function assumeFacilityMargins(lane: CreateOrUpdateHlaLane): [number, number] {
  var assumedLaneWidth =
    lane.facilityWidthPerDirection === FacilityWidth.VeryNarrow
      ? 0.8
      : lane.facilityWidthPerDirection === FacilityWidth.Narrow
      ? 1.5
      : 2.8;

  return lane.flowDirection === FlowDirectionType.TwoWay
    ? [assumedLaneWidth * 1.5, assumedLaneWidth * 0.5]
    : [assumedLaneWidth * 0.5, assumedLaneWidth * 0.5];
}
